export default __webpack_public_path__ + "static/media/ventil1.fc97ff00.jpg";